<template lang="pug">
    .component-backoffice-plan(v-if="item")
        .plan-data(v-if="$is('plan-data')")
            .row
                .columns
                    strong Plan Details
                    h2 {{item.name}}
                    p {{item.descriptions}}
                .columns
                    strong Duration
                    h3 {{item.duration}} Days
                .columns
                    span
                        strong Min Driving Price
                        h3 --
                    span
                        strong Max Driving Price
                        h3 --
                .columns
                    span
                        strong Min Reserv. Price
                        h3 --
                    span
                        strong Max Reserv. Price
                        h3 --
        .plan-list(v-if="$is('listing')")
            .card
                .inner-content
                    card4(:showAction="true")
                        .field-plan-name(slot="n1")
                            .field-value {{item.id}}
                            .field-value {{item.name}}
                        .field-booking-mode(slot="n2")
                            .field-value {{item.booking_mode}}
                        .field-plan-cost(slot="n3")
                            .field-value {{currency}}{{item.cost}}
                        .field-plan-status(slot="n4")
                            .field-value {{item.status}}
                        div(slot="actionPage")
                            router-link(:to="{name:'plan',params:{id:item.id}}")
                                i.fa.fa-angle-right.fa-3x.action
</template>
<script type="text/babel">
    import Card4 from "../structure/Card4.vue"
    import {mapState} from 'vuex'

    export default {
        name: "Plan",
        components: {Card4},
        data() {
            return {}
        },
        created() {
        },
        computed: {
          ...mapState({
            configuration: state => state.configuration,
          }),
          currency() {
            return this.configuration.commercial.commercial_currency.value
          },
        },
        methods: {},
        props: {
            item: Object,
            type: {
                type: String,
                default: ''
            }
        },
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Plan.vue?736e8cdb